module.exports = __webpack_public_path__ + "img/depoimentos.b4b76915.jpg";